import {ModalWindow} from "./modalWindow.js";

export class ModalMenu extends ModalWindow {

   constructor(options) {
      super();

      this.panel.classList.add('modal-menu');
      this.elMain = HTMLElement.createFromHTML(`
         <div class="menu"></div>
      `);

      for (let item of options.items) {
         const elItem = HTMLElement.createFromHTML(`
            <div class="button">${item.label}</div>
         `);
         elItem.onclick = item.onSelect;
         this.elMain.append(elItem);
      }
      
      const positions = options.position.corner.match(/^(top|bottom) (left|right)$/);
      if (!positions) console.error("Ungültige Angabe corner: " + options.position.corner);
      else {
         for (let dim of positions.slice(1)) {
            this.elMain.style[dim] = (['top', 'bottom'].includes(dim) ? options.position.offset.y : options.position.offset.x) + 'px';
         }
      }

      
      this.panel.append(this.elMain);
      requestAnimationFrame(() => {
         this.elMain.classList.add('show');
      })

      this.panel.addEventListener('click', () => {
         this.close();
      })

      setTimeout(() => this.show(), 1);

   }
}
